import { Types } from "../actions/TwoDCode.actions";

const INITIAL_STATE = {
  success: false,
  loading: false,
  error: null,
  data: null
};

export default function activateUser(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_2D_CODE: {
      return {
        ...state,
        ...INITIAL_STATE,
        loading: true
      };
    }

    case Types.GET_2D_CODE_SUCCESS: {
      return {
        ...state,
        success: true,
        loading: false,
        data: action.payload
      };
    }

    case Types.GET_2D_CODE_ERROR: {
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    }

    case Types.GET_2D_CODE_RESET: {
      return {
        ...state,
        ...INITIAL_STATE
      };
    }

    default:
      return state;
  }
}
